<template>
  <div class="tabs is-centered tabs-mobile">
    <ul>
      <li>
        <a>
          <router-link to="/dashaluno">
            <span class="icon is-small">
              <img src="../../assets/images/icon-color/home.svg" />
            </span>
          </router-link>
        </a>
      </li>
      <li>
        <a>
          <span class="icon is-small">
            <img src="../../assets/images/icon-color/notification.svg" />
          </span>
        </a>
      </li>
      <li>
        <a>
          <router-link :to="{ name: 'redacao', params: { cargo_id } }">
            <span class="icon is-small">
              <img src="../../assets/images/icon-color/file.svg" />
            </span>
          </router-link>
        </a>
      </li>
      <li>
        <a @click="$router.push({ name: cargo+'/perfil', params: { cargo_id }})">
          <span class="icon is-small">
            <img src="../../assets/images/icon-color/profile.svg" />
          </span>
        </a>
      </li>
      <li>
        <div class="newR">
          <a @click="$router.push({ name: 'redacao/create'})">
            <img src="../../assets/images/icon-color/newR.svg" />
          </a>
        </div>
      </li>
    </ul>
  </div>
</template>
<script>
//import PropostaService from "@/services/PropostaService";
import store from "@/store";

export default {
  data() {
    return {
      propostas: [],
      proposta: [],
      cargo: store.getters.cargo,
      cargo_id: store.getters.cargo_id
    };
  },
  created() {
    //PropostaService.Index(this.cargo_id).then(result => {
    //  this.propostas = result;
    //});
  }
};
</script>
<style scoped>
.tabs ul li {
  background-color: white !important;
}
.tabs ul {
  margin-left: 0;
}
</style>